<template>
  <div id="emailEvents">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-2"
        >
          <section class="pt-3">
            <div class="section-title">
              Unindexed URLs
            </div>
          </section>
          <form
            @change.prevent="getURLs(false)"
            class="d-flex align-items-center mb-2"
          >
            <div class="d-inline-flex mr-1">
              <input
                v-model.number.trim="form.take"
                class="form-control"
                type="number"
                style="max-width: 80px;"
              >
            </div>
            <div class="d-inline-flex mr-1">
              <select
                class="form-control"
                v-model="form.language"
              >
                <option value="">
                  Any Language
                </option>
                <optgroup label="Specific Language">
                  <option
                    v-for="l in languages"
                    :key="l.code"
                    :value="l.code"
                  >
                    {{ l.name }}
                  </option>
                </optgroup>
              </select>
            </div>
            <div class="d-inline-flex mr-1">
              <select
                class="form-control"
                v-model="form.section"
              >
                <option value="information">
                  Information
                </option>
              </select>
            </div>
            <div class="d-inline-flex mr-1">
              <input
                v-model.trim="form.urlFilter"
                class="form-control"
                type="text"
                placeholder="URL Filter"
              >
            </div>
            <div class="d-inline-flex mr-1">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-processable"
                  v-model="form.processable"
                >
                <label
                  class="custom-control-label"
                  for="switch-processable"
                >Processable</label>
              </div>
            </div>
          </form>
          <section class="d-flex justify-content-between mb-2">
            <div>
              <div
                class="btn-group"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="getURLs(false)"
                >
                  Refresh
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="loadMore"
                >
                  Load More
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-success"
                  :disabled="selectedCount === 0"
                  @click="activateSelected"
                >
                  Activate
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  :disabled="selectedCount === 0"
                  @click="deactivateSelected"
                >
                  Deactivate
                </button>
              </div>
              <p
                v-if="selectedCount !== 0"
                class="m-0 text-muted d-inline-flex"
              >
                {{ selectedCount }} Selected
              </p>
            </div>
            <div>
              <p class="m-0 text-muted">
                {{ urls.length }} Loaded
              </p>
            </div>
          </section>
          <section
            id="result-container"
            class="table-responsive"
          >
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>
                    <div class="form-group form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="form.allSelected"
                        @change="selectAll"
                      >
                    </div>
                  </th>
                  <th>ID</th>
                  <th>URL</th>
                  <th>Date Last Crawled</th>
                  <th>Website Section</th>
                  <th>Language</th>
                  <th>URL Meta</th>
                  <th>Processable</th>
                  <th>Date Created</th>
                  <th>Date Updated</th>
                  <th>URL Inspection Result</th>
                  <th>Date Last Inspected</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="u in urls"
                  :key="u.id"
                >
                  <td>
                    <div class="form-group form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :checked="selected.find(x => x.id === u.id).selected"
                        @change="select(u.id)"
                      >
                    </div>
                  </td>
                  <td>{{ u.id }}</td>
                  <td>
                    <a
                      :href="u.url"
                      target="_blank"
                    >{{ u.url }}</a>
                  </td>
                  <td>{{ u.dateLastCrawled ? new Date( u.dateLastCrawled ).toLocaleDateString() : 'null' }}</td>
                  <td>{{ u.websiteSection }}</td>
                  <td>{{ u.language }}</td>
                  <td>{{ u.urlMeta }}</td>
                  <td>{{ u.processable }}</td>
                  <td>{{ u.dateCreated ? new Date( u.dateCreated ).toLocaleDateString() : 'null' }}</td>
                  <td>{{ u.dateUpdated ? new Date( u.dateUpdated ).toLocaleDateString() : 'null' }}</td>
                  <td>{{ u.urlInspectionResult }}</td>
                  <td>{{ u.dateLastInspected ? new Date( u.dateLastInspected ).toLocaleDateString() : 'null' }}</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../../../http';
import notify from '../../../../notifications';
import languages from '../../../../models/languages';

export default {
    data() {
        return {
            urls: [],
            selected: [],
            form: {
                take: 25,
                language: 'en',
                section: 'information',
                urlFilter: '',
                processable: true,
                allSelected: false
            }
        };
    },
    computed: {
        languages() {
            return languages;
        },
        selectedCount() {
            return this.selected.filter( x => x.selected ).length;
        }
    },
    methods: {
        selectAll() {
            const allSelected = this.selected.every( x => x.selected );

            this.selected = this.selected.map( x => {
                return {
                    id: x.id,
                    selected: allSelected ? false : true
                };
            } );
        },
        select( id ) {
            this.selected = this.selected.map( x => {
                return {
                    id: x.id,
                    selected: x.id === id ? !x.selected : x.selected
                };
            } );
        },
        async activateSelected() {
            this.$store.dispatch( 'appLoading', true );

            const params = new URLSearchParams();
            params.set( 'ids', this.selected.filter( x => x.selected ).map( x => x.id ) );

            const response = await http.get( '/unindexed-urls/activate?' + params.toString() );

            if ( response.status != 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    title: 'error occured',
                    text: 'please try again later'
                } );
                return;
            }

            this.form.allSelected = false;
            this.selectAll();

            await this.getURLs();

            this.$store.dispatch( 'appLoading', false );
        },
        async deactivateSelected() {
            this.$store.dispatch( 'appLoading', true );

            const params = new URLSearchParams();
            params.set( 'ids', this.selected.filter( x => x.selected ).map( x => x.id ).join( ',' ) );

            const response = await http.get( '/unindexed-urls/deactivate?' + params.toString() );

            if ( response.status != 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    title: 'error occured',
                    text: 'please try again later'
                } );
                return;
            }

            this.form.allSelected = false;
            this.selectAll();

            await this.getURLs();

            this.$store.dispatch( 'appLoading', false );
        },
        async loadMore() {
            await this.getURLs( true );
        },
        async getURLs( loadNextPage = false ) {
            this.$store.dispatch( 'appLoading', true );

            const params = new URLSearchParams();
            params.set( 'take', this.form.take );
            params.set( 'language', this.form.language );
            params.set( 'section', this.form.section );
            params.set( 'processable', this.form.processable );

            if ( loadNextPage ) {
                params.set( 'offset', this.urls.length );
            }

            if (  this.form.urlFilter && this.form.urlFilter.length > 0 ) {
                params.set( 'url', this.form.urlFilter );
            }

            const response = await http.get( '/unindexed-urls?' + params.toString() );

            if ( response.status != 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    title: 'error occured',
                    text: 'please try again later'
                } );
                return;
            }

            const urls = await response.json() || [];

            if ( loadNextPage ) {
                this.urls = [
                    ...this.urls || [],
                    ...urls || []
                ];
            } else {
                this.urls = urls || [];
            }

            this.selected = this.urls.map( u => {
                return {
                    id: u.id,
                    selected: false
                };
            } );

            this.$store.dispatch( 'appLoading', false );
        }
    },
    mounted() {
        this.getURLs( false );
        document.title = 'thinkSPAIN - Unindexed URLs';
    }
};
</script>
<style>
  #result-container {
    max-height: 500px;
  }

  #result-container th {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/gsc/unindexed-urls/ViewURLs.vue